import { Component, Input } from "@angular/core";
import { LoginLayoutData } from "./index-layout.type";

@Component({
  selector: "app-index-layout",
  templateUrl: "./index-layout.component.html",
  styleUrls: ["./index-layout.component.scss"],
})
export class IndexLayoutComponent {
  @Input() layoutData: LoginLayoutData;
}
